import { Base } from '@studiometa/js-toolkit';

/**
 * StickyBar
 */
export default class StickyBar extends Base {
  static config = {
    name: 'StickyBar',
    refs: ['btn'],
    options: {
      // CSS selector of the main buy box CTA the sticky button proxies.
      target: String,
    },
  };

  isVisible = false;

  /**
   * Service scrolled hook
   * @see https://js-toolkit.studiometa.dev/api/methods-hooks-services.html#scrolled
   * @param {object} props Props
   * @param {number} props.y The current vertical scroll position.
   * @returns {void}
   */
  scrolled() {
    const position = this.addToCartPosition;
    if (this.isVisible && position >= 50) {
      this.$el.classList.add('translate-y-[100px]');
      this.isVisible = false;
      return;
    }

    if (!this.isVisible && position < 50) {
      this.isVisible = true;
      this.$el.classList.remove('translate-y-[100px]');
    }
  }

  /**
   * Forward the click to the main buy box CTA.
   *
   * The sticky button is only a proxy: the CTA rendered in `#main-add-to-cart`
   * stays the single source of truth, may it be the ajax cart submit button,
   * the waitlist form or the Quote Snap button. Which one to click is resolved
   * in Liquid, from the product template.
   * @returns {void}
   */
  onBtnClick() {
    const { target } = this.$options;

    if (!target) {
      return;
    }

    const mainCta = document.querySelector(target);

    if (mainCta) {
      mainCta.click();
    }
  }

  /**
   * Get Main Add To Cart position
   * @returns {number}
   */
  get addToCartPosition() {
    return document.querySelector('#main-add-to-cart').getBoundingClientRect().top;
  }
}
